import axios from "axios";
import { base_url, image_url, SEO_IMAGE_PATH } from "../../Utils/baseUrl";

/**
 * Client for the admin-managed SEO landing pages.
 *
 * These endpoints already existed in food-services (web.route.js:240-243) and
 * are driven by the seoPages / seoCategories tables that the admin panel
 * writes to. What was missing was any SPA route that rendered them — only a
 * bot-only EJS renderer existed server-side. These functions back the real
 * React routes, so users and crawlers are served the same markup.
 */

/** Resolves a stored filename to a displayable URL. */
export function seoImageUrl(image) {
  if (!image) return undefined;
  if (/^https?:\/\//i.test(image)) return image;
  return `${image_url}${SEO_IMAGE_PATH}${image}`;
}

export async function getSeoPageBySlug(slug) {
  const { data } = await axios.get(`${base_url}seo-pages/${encodeURIComponent(slug)}`);
  return data?.status ? data.data : null;
}

export async function getSeoCategoryBySlug(categorySlug) {
  const { data } = await axios.get(
    `${base_url}seo-category/${encodeURIComponent(categorySlug)}`
  );
  return data?.status ? data.data : null;
}

export async function getSeoPagesByCategorySlug(categorySlug) {
  const { data } = await axios.get(
    `${base_url}seo-pages/category/${encodeURIComponent(categorySlug)}`
  );
  return data?.status ? data.data : null;
}

export async function getSeoCategories() {
  const { data } = await axios.get(`${base_url}seo-categories`);
  return data?.status ? data.data || [] : [];
}

export default {
  seoImageUrl,
  getSeoPageBySlug,
  getSeoCategoryBySlug,
  getSeoPagesByCategorySlug,
  getSeoCategories,
};
